import { useEffect, useRef } from "react";
import { fetchJson, extractReturnUrl } from "../utils/api";
import { TransactionStatus, POLL_INTERVAL } from "../constants/payment";

/**
 * Custom hook for polling return URL after payment is initiated
 */
export function useReturnUrlPolling(
  qrPayload,
  orderId,
  returnUrlApi,
  status
) {
  const pollTimerRef = useRef(null);

  useEffect(() => {
    if (!qrPayload || status !== TransactionStatus.WAIT_PAY) {
      return;
    }

    const controller = new AbortController();

    const fetchRedirectUrl = async () => {
      try {
        const { body } = await fetchJson(
          `${returnUrlApi}/${encodeURIComponent(orderId)}`,
          { signal: controller.signal }
        );

        const url = extractReturnUrl(body);

        if (typeof url === "string" && url.length > 0) {
          window.location.replace(url);
          return;
        }

        // Continue polling if no URL found
        pollTimerRef.current = window.setTimeout(
          fetchRedirectUrl,
          POLL_INTERVAL
        );
      } catch (e) {
        if (e?.name === "AbortError") return;
        // Silent fail and retry
        pollTimerRef.current = window.setTimeout(
          fetchRedirectUrl,
          POLL_INTERVAL
        );
      }
    };

    fetchRedirectUrl();

    return () => {
      controller.abort();
      if (pollTimerRef.current) {
        clearTimeout(pollTimerRef.current);
      }
    };
  }, [qrPayload, orderId, returnUrlApi, status]);
}